<!--虚拟设备树
可以单选的树形图，针对虚拟设备树，根据type字段决定图标
双击展开收起
可以配置组能不能选中
-->
<template>
	<baseTree ref="treeBean" :dataList="dataList" :multiCheckedItems="multiCheckedItems" :groupCheckAble="groupCheckAble" class="treeBody" :autoSelectMethod="autoSelectMethod"
	 :typeImgNameList="typeImgNameList" :getTypeImgIndex="getTypeImgIndex" :isGroup="isGroup" :isSameItem="isSameItem"
	 :isDisAble='isDisAble' :baseTreeStyle="baseTreeStyle" :checkImgNameList="checkImgNameList" :multiSelect="multiSelect"
	 :getCheckImgIndex="getCheckImgIndex" :checkShowAble="checkShowAble" @checkItem="$emit('checkItem', $event)"
	 :getIDMethod="getIDMethod" :stateShowAble="stateShowAble">
	</baseTree>
</template>

<script>
	import baseTree from '@/components/module/tree/baseTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			baseTree,
			imageView,
		},
		props: {
			isDisAble: {
				type: Function,
				default (item) {
					return false
				}
			},
			baseTreeStyle: {
				type: Object,
				default () {
					return {}
				}
			},
			checkShowAble: {
				type: Function,
				default (item, index) {
					return this.groupCheckAble ? (this.multiSelect) : (!this.isGroup(item) && this.multiSelect)
				}
			},
			multiSelect: {
				type: Boolean,
				default: false
			},
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			multiCheckedItems: {
				type: Array,
				default () {
					return []
				}
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					//默认是找到第一个设备
					return item.type == 'virtualDevice'
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
			stateShowAble: {
				type: Function,
				default (item, index) {
					return this.isGroup(item) && !isempty(this.getNextMethod(item))
				}
			},
			isGroup: {
				type: Function,
				default (item) {
					return item.entityName == 'AppClassType'
				}
			},
			getIDMethod: {
				type: Function,
				default (item) {
					return item.no
				}
			}
		},
		data() {
			return {
				typeImgNameList: [
					'tree/node_unit.png', 'tree/node_class.png', 'tree/node_dev.png',
					'tree/node_unit_select.png', 'tree/node_class_select.png', 'tree/node_dev_select.png'
				],
				checkImgNameList: ['checkBox/checked.png', 'checkBox/unchecked.png']
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			getTypeImgIndex() {
				return item => {
					var treeB = this.$refs.treeBean
					if (treeB == undefined) {
						treeB = {}
					}
					var nowData = treeB.nowCheckItem ? treeB.nowCheckItem : this.multiSelect ? [] : {}
					if (this.multiSelect) {
						if (nowData.includes(item)) {
							if (!isempty(item.unitid)) {
								return 3
							}
							if (this.isGroup(item)) {
								return 4
							}
							return 5
						} else {
							if (!isempty(item.unitid)) {
								return 0
							}
							if (this.isGroup(item)) {
								return 1
							}
							return 2
						}
					} else {
						if (this.isSameItem(item, nowData)) {
							if (!isempty(item.unitid)) {
								return 3
							}
							if (this.isGroup(item)) {
								return 4
							}
							return 5
						} else {
							if (!isempty(item.unitid)) {
								return 0
							}
							if (this.isGroup(item)) {
								return 1
							}
							return 2
						}
					}
				}

			},
		},
		watch: {},
		methods: {
			isSameItem(item, nowItem) {
				if (this.multiSelect) { //多选
					if (nowItem == undefined) {
						return item == nowItem
					}
					for (var temp of nowItem) {
						if (item.id == temp.id && item.type == temp.type) {
							return true
						}
					}
					return false

				} else { //单选
					if (nowItem == undefined || item == undefined) {
						return item == nowItem
					}
					return item.id == nowItem.id && item.type == nowItem.type
				}
			},
			getCheckImgIndex(item, datas) {
				if (datas == undefined || !this.multiSelect) {
					return 1
				} else {
					return datas.indexOf(item) > -1 ? 0 : 1
				}
			},
			setNowCheckItem(item) {
				this.$refs.treeBean.nowCheckItem = item
			}
		}
	}
</script>

<style scoped>
</style>
